import React from "react";
import '../css/Style.css';
import { Autoplay } from 'swiper/modules';
import apple from '../img/icons8-apple-fruit-64.png';
import banana from '../img/icons8-banana-100.png';
import grapes from '../img/icons8-grapes-64.png';
import mango from '../img/icons8-mango-64.png';
import orange from '../img/icons8-orange-100.png';
import guava from '../img/icons8-guava-96.png';
import pomegranate from '../img/icons8-pomegranate-100.png';
import papaya from '../img/icons8-papaya-64.png';
import coconut from '../img/icons8-coconut-64.png';
import lemon from '../img/icons8-citrus-96.png';
import pineapple from '../img/icons8-pineapple-100.png';
import watermelon from '../img/icons8-watermelon-64.png';

function OurFruits(){
    return(<>
       <div className="container-fluid bg-secondary mb-5">
            <div className="container py-3">
            <div class="d-flex justify-content-between ">
              <div className="fw-bold text-white  " > OurFruits</div>
              <div  className="fw-bold text-white ">Home > OurFruits</div>
                </div>
            </div>
         </div>

  <div class="px-4 pt-4 my-5 text-center">
    <h1 class="display-4 fw-bold bg_text">First Class Fruits</h1>
    <div className="fancy-border"></div>
    <div class="col-lg-8 mx-auto">
      <p class="lead mb-4 mt-3 text-muted">
      A fruits shop offers first-class fruits, which are the finest quality produce known for their exceptional taste, freshness, and nutritional value. These fruits are carefully selected, ensuring vibrant colors, rich flavors, and top-notch quality. Examples found in a fruits shop include premium varieties of apples, oranges, berries, and tropical fruits, providing customers with the best in taste and nutrition.

      </p>
     
    </div>
    <div class="overflow-hidden">
      <div class="container px-5">
        <img src="https://preston.axiomthemes.com/wp-content/uploads/2016/10/depositphotos-13693648-processed.png" class="img-fluid mb-4" alt="Example image" />
      </div>
    </div>
  </div>


  <div className="container-fluid mt-5 mb-5">
    <div className="container">
       <div className="row bg rounded py-3 p-3 ">
           <div className="col-lg-8">
               <h3 className="text-white text-start fw-bold p-2" >Fresh Fruits Grown with Love!</h3>
               <div className="fancy-border_left"></div>
               <p className=" text-white text-start fs-6 p-2">Providing the best of the best produce for our customers. Hand-selected the freshest fruits.</p>
           </div>
           <div className="col-lg-4 align-middle mt-4">
           <button to="/about" type="button" class="btn bg-light btn-lg px-4 me-md-2">Visit the Shop </button>
           </div>
       </div>
    </div>

  </div>


  <div className="container mt-5 mb-5">
  <div className="row mb-2">
            <div className="about_title">
                <p className="fw-bold">WHAT'S FRESH</p>
                <h3 className="fw-bold bg_text">Check Our Range</h3>
                <div class="fancy-border"></div>
            </div>
            </div>


       <div className="row mt-5">
        <div className="col-lg-4 mb-3">
        <div className="card_height">
        <div class="card p-1 ">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={apple} class="img-fluid rounded-start mx-auto d-block" alt="apple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start mb-0 lead text-muted fw-bold">Fresh Apple </h5>
                 <p className=" text-start"><small className="text-muted">Crisp and more sweet, and  classic fruit.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
        <div className="col-lg-4 mb-3">
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={banana} class="img-fluid rounded-start mx-auto d-block" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead mb-0 fw-bold text-muted">Fresh Banana </h5>
                <p className=" text-start"><small className="text-muted">Yellow and portable, a potassium-packed snack..</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
        <div className="col-lg-4 mb-3">
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={orange} class="img-fluid rounded-start mx-auto d-block" alt="orange" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead fw-bold mb-0 text-muted">Fresh Orange </h5>
                <p className=" text-start"><small className="text-muted">Citrusy and juicy, a burst of vitamin C.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
        <div className="col-lg-4 mb-3">
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={grapes} class="img-fluid rounded-start mx-auto d-block" alt="grapes" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start mb-0 fw-bold lead text-muted"> Green Grapes </h5>
                <p className=" text-start"><small className="text-muted">Small and sweet, nature's bite-sized treats.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
       
       <div className="col-lg-4 mb-3">
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={guava} class="img-fluid rounded-start mx-auto d-block" alt="guava" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Ripe Guava </h5>
                <p className=" text-start"><small className="text-muted"> Crisp and tropical, a sweet treat in the late winter.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>

       <div className="col-lg-4 mb-3" >
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={mango} class="img-fluid rounded-start mx-auto d-block" alt="apple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh Ripe Mango </h5>
                <p className=" text-start"><small className="text-muted">Sweet and tropical, a juicy indulgence.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>


        <div className="col-lg-4 mb-3" >
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={pomegranate} class="img-fluid rounded-start mx-auto d-block" alt="apple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Pomegranate</h5>
                <p className=" text-start"><small className="text-muted">Jewel-like seeds, bursting with antioxidants.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
          </div> 
        <div className="col-lg-4 mb-3" >
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={papaya} class="img-fluid rounded-start mx-auto d-block" alt="papaya" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Papaya</h5>
                <p className=" text-start"><small className="text-muted">Sweet and succulent, taste of the monsoon.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
          </div> 
        <div className="col-lg-4 mb-3" >
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={coconut} class="img-fluid rounded-start mx-auto d-block" alt="coconut" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted mb-0 fw-bold">Fresh Coconut</h5>
                <p className=" text-start"><small className="text-muted">  Nutty and versatile, a staple ingredient </small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
          </div> 
        <div className="col-lg-4 mb-3" >
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={pineapple} class="img-fluid rounded-start mx-auto d-block" alt="pineapple" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh PineApple</h5>
                <p className=" text-start"><small className="text-muted"> Tangy and tropical a perfect addition to spring. </small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>

        <div className="col-lg-4 mb-3" >
        <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={lemon} class="img-fluid rounded-start mx-auto d-block" alt="orage/lemon" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh CrutsFruits</h5>
                <p className=" text-start"><small className="text-muted">angy and tropical, a perfect addition to spring.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
          </div> 
          <div className="col-lg-4 mb-3" >
          <div className="card_height">
        <div class="card p-1 bg card_height">
          <div class="row g-0">
            <div class="col-md-4">
              <img src={watermelon} class="img-fluid rounded-start mx-auto d-block" alt="watermelon" />
            </div>
            <div class="col-md-8">
              <div class="card-body">
                <h5 class="card-title text-start lead text-muted fw-bold mb-0">Fresh Watermelon</h5>
                <p className=" text-start"><small className="text-muted">Sweet juicy and perfect red in summber good for health.</small></p>
              </div>
            </div>
          </div>
        </div>
        </div>
          </div>
  </div>     

  </div>
    </>);
}
export default OurFruits;